import { useDebounce } from 'use-debounce'
import { FC, useState, useEffect } from 'react'

import { Input } from '~ui'
import { useQueryParams } from '~hooks'

type SearchInputProps = {
  placeholder: string
}

const SearchInput: FC<SearchInputProps> = ({ placeholder }) => {
  const { query, replace } = useQueryParams()
  const [value, setValue] = useState(query.query)

  const [debouncedValue] = useDebounce(value, 300)

  useEffect(() => {
    replace({ query: { ...query, query: debouncedValue } }, null, { shallow: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue])

  return (
    <Input
      icon="loupe"
      value={value}
      placeholder={placeholder}
      onChange={(e) => setValue(e.target.value)}
    />
  )
}

export default SearchInput
